import { PublishedTaskEditorTask } from "./taskEditorRuntime";

export interface TaskEditorListSection {
  key: string;
  label: string;
  set_number?: number;
  tasks: PublishedTaskEditorTask[];
}

function compareTaskEditorTasks(
  left: PublishedTaskEditorTask,
  right: PublishedTaskEditorTask
) {
  const titleCompare = left.title.localeCompare(right.title, "ko");

  if (titleCompare !== 0) {
    return titleCompare;
  }

  return left.task_id.localeCompare(right.task_id, "ko");
}

export function getTaskEditorSetSectionLabel(set_number?: number) {
  return typeof set_number === "number" ? `세트 ${set_number}` : "미분류";
}

export function buildTaskEditorListSections(
  tasks: PublishedTaskEditorTask[]
): TaskEditorListSection[] {
  if (!Array.isArray(tasks)) {
    return [];
  }

  const groupedTasks = new Map<string, TaskEditorListSection>();

  tasks.forEach((task) => {
    if (!task) {
      return;
    }

    const key =
      typeof task.set_number === "number" ? `set-${task.set_number}` : "unset";
    const existingSection = groupedTasks.get(key);

    if (existingSection) {
      existingSection.tasks.push(task);
      return;
    }

    groupedTasks.set(key, {
      key,
      label: getTaskEditorSetSectionLabel(task.set_number),
      set_number: task.set_number,
      tasks: [task],
    });
  });

  return Array.from(groupedTasks.values())
    .map((section) => ({
      ...section,
      tasks: [...section.tasks].sort(compareTaskEditorTasks),
    }))
    .sort((left, right) => {
      if (left.set_number === undefined) {
        return right.set_number === undefined ? 0 : 1;
      }

      if (right.set_number === undefined) {
        return -1;
      }

      return left.set_number - right.set_number;
    });
}
